export const attributeTypes = {
  NUMBER: 'NUMBER',
  OBJECT: 'OBJECT',
  TEXT: 'TEXT',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
};
